import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PatrolAreaService {

  constructor(private httpClient: HttpClient) { }

  async getPatrolArea(areaId: string){
    const result: any = await this.httpClient.get(`plan/api/business/patrolarea/area/${areaId}`).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }
  async getPatrolAreaByAreaNo(areaNo: string){
    const result: any = await this.httpClient.get(`plan/api/business/patrolarea/area?areaNo=${areaNo}`).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }
  async getPatrolAreasByCondition(parm: any, pageNum: number, pageSize: number){
    let url = 'plan/api/business/patrolarea/areas' + '?pageNum=' + pageNum +
    '&pageSize=' + pageSize;
    if (!this.isEmpty(parm.areaNo)) {
      url = url + '&areaNo=' + parm.areaNo;
    }
    if (!this.isEmpty(parm.areaName)) {
      url = url + '&areaName=' + parm.areaName;
    }
    if (!this.isEmpty(parm.areaType)) {
      url = url + '&areaType=' + parm.areaType;
    }
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret.data;
  }
  // 新增巡检区域
  addPatrolArea(patrolArea: any): Observable<any[]> {
    return this.httpClient.post(`plan/api/business/patrolarea/area`, patrolArea).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }

  // 批量删除巡检区域
  batchDeletePatrolAreas(ids: any){
    const ls: string[] = Array.from(ids);
    return this.httpClient.delete(`plan/api/business/patrolarea/areas`, {
      params: {ids: ls}
  } ).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  // 删除巡检区域
  deletePatrolArea(areaNo: any){
    return this.httpClient.delete(`plan/api/business/patrolarea/area`, {
      params: {areaNo}
  } );
  }
  // 更新巡检区域
  updatePatrolArea(patrolArea: any) {
    return this.httpClient.put('plan/api/business/patrolarea/area', patrolArea).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  /**
   * 查询区域类型信息
   */
   async getAreaType() {
    const url = 'plan/api/business/patrolarea/types';
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret.data;
  }
  /**
   * 查询区域位置信息
   */
   async getAreaLocation() {
    const url = 'plan/api/business/patrolarea/locations';
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret.data;
  }
  // 根据过滤字符串查询符合条件的区域列表（区域名称或区域编号中包含areaLike）
  getAreasByFilterString(areaLike): Observable<any[]> {
    let url = 'plan/api/business/patrolarea';
    url = url + '/areasByFilterString?areaLike=' + areaLike;
    return this.httpClient.get(url).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
